import { render, staticRenderFns } from "./VisualizarFornecedoresCotacaoDialog.vue?vue&type=template&id=f7b7df1e&scoped=true"
import script from "./VisualizarFornecedoresCotacaoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarFornecedoresCotacaoDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b7df1e",
  null
  
)

export default component.exports